import type { ProductEventDataList } from 'corgi-types';

import { WishlistButtonEvent } from '../../enums/Tracking';
import { dispatchTrackingEventGA4 } from '../../tracking/dispatchTrackingEventGA4';
import { getProductWishlistEventData } from '../../tracking/productEventData';
import type { ArticleTracking } from '../../types/Article';

type DispatchWishlistEventParams = {
  wishlistState: boolean;
  tracking?: ArticleTracking;
  position?: number;
  list?: ProductEventDataList;
};

export const dispatchWishlistEvent = ({
  wishlistState,
  tracking,
  position,
  list,
}: DispatchWishlistEventParams) => {
  if (tracking) {
    const wishlistTrackingProps = getProductWishlistEventData({
      tracking,
      position,
      quantity: 1,
      list,
    });
    dispatchTrackingEventGA4({
      event: wishlistState
        ? WishlistButtonEvent.AddToWishlist
        : WishlistButtonEvent.RemoveFromWishlist,
      value: wishlistTrackingProps.price,
      currency: tracking.productPriceCurrency,
      items: [wishlistTrackingProps],
    });
  }
};
